export const tr = {
    cancel: 'İptal',
    'check-all': 'Tümünü ({total} ad.) seç',
    copy: 'Kopyala',
    crop: 'Yeniden kırp',
    'filtered-items': 'Filtrelenenler: {filteredOut} ad.',
    'item-id': 'ID: {id}',
    'item-size': '{width}x{height}',
    submit: 'Boyutları seç',
    title: '"{creativeName}" grubu boyutları'
};
